module.exports = __webpack_public_path__ + "img/default-res-icon.41d0b60c.svg";